import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';


export const SettingsTopBar: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-md z-50 shadow-sm">
      <div className="px-6">
        <div className="flex items-center justify-between h-20">
          {/* Left side - Logo and Back button */}
          <div className="flex items-center gap-6">
            {/* Logo */}
            <Link to="/" className="flex items-center hover:opacity-80 transition-all duration-200">
              <span className="text-3xl font-semibold text-black tracking-tight">
                anthrogen:drift
              </span>
            </Link>

            {/* Back button */}
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-sm transition-all duration-200"
            >
              <ChevronLeft className="w-5 h-5" />
              <span className="text-sm font-medium">Back</span>
            </button>
          </div>

          {/* Right side - Empty for clean look */}
          <div></div>
        </div>
      </div>
    </div>
  );
};